// extracted by mini-css-extract-plugin
export default {"confirmation_container":"Confirmation_confirmation_container__eBk5Y"};